module.exports = __webpack_public_path__ + "img/2.c44bd218.jpg";